'use strict';

import './similarVehicles.scss';
import template from './similarVehicles.template.html';
import controller from './similarVehicles.controller.js';

/* istanbul ignore next */
function component(pageStateService) {
    return {
        restrict: 'E',
        scope: {
            pageName: "@",
            disableCustomlinkFire: '@',
            listingId: '@',
            displayLotTour: '<'
        },
        controllerAs: 'similarVehicles',
        controller,
        template,
        link
    };
    function link (scope, el, attr, ctrl) {
        const TRACK_SWIPE_THRESHOLD = 10; //Number of pixels that must be swiped to fire tracking

        var mousewheelHandler, touchstartHandler, touchendHandler,
            calculateMaxPage, calcViewMoreTilePadding, compDisableRightArrow,
            scrollableContentDiv = el[0].getElementsByClassName('scrollable-content')[0],
            carWidth = 0,
            scrollableContentWidth = 0,
            animating = false,
            touchstartScrollLeft = 0;

        scope.page = 0;
        scope.maxPage = 0;
        scope.viewMoreTilePadding = 0;
        scope.disableRightArrow = false;

        mousewheelHandler = function (event) {
            if (animating) {
                event.preventDefault();
            }
            return false;
        };

        touchstartHandler = function () {
            touchstartScrollLeft = scrollableContentDiv.scrollLeft;
        };

        touchendHandler = function () {
            var touchendScrollLeft = scrollableContentDiv.scrollLeft;
            if (Math.abs(touchendScrollLeft - touchstartScrollLeft) >= TRACK_SWIPE_THRESHOLD) {
                if (touchendScrollLeft > touchstartScrollLeft) {
                    ctrl.trackSwipeRight();
                } else {
                    ctrl.trackSwipeLeft();
                }
            }
        };

        scrollableContentDiv.addEventListener('mousewheel', mousewheelHandler, false);
        scrollableContentDiv.addEventListener('touchstart', touchstartHandler, false);
        scrollableContentDiv.addEventListener('touchend', touchendHandler, false);

        calculateMaxPage = function () {
            scope.maxPage = Math.ceil(scope.resultsShow / ctrl.getCarsPerPage());
        };

        scope.calculateDomInfo = function () {
            carWidth = scrollableContentDiv.getElementsByClassName('car-wrapper')[0].offsetWidth;
            scrollableContentWidth = scrollableContentDiv.offsetWidth;
            calculateMaxPage();
            compDisableRightArrow();
        };

        scope.scrollLeft = function () {
            pageStateService.push('event', {eventName: "custom-link"}, true);
            if (scope.page === scope.maxPage - 1 + scope.viewMoreTilePadding && !hasEmptySlot() && ctrl.showViewMoreTile()) {
                scope.page -= scope.viewMoreTilePadding;
            } else if (scope.page > 0) {
                scope.page--;
            }
            compDisableRightArrow();
        };

        scope.scrollRight = function () {
            pageStateService.push('event', {eventName: "custom-link"}, true);
            calculateMaxPage();
            calcViewMoreTilePadding();
            if (scope.page < scope.maxPage - 1) {
                scope.page++;
            } else if (scope.page === scope.maxPage - 1 && !hasEmptySlot() && ctrl.showViewMoreTile()) {
                scope.page += scope.viewMoreTilePadding;
            }
            compDisableRightArrow();
        };

        //scope.viewAllAlsCall = function () {
        //    als.clickthru.fromDrv({
        //        listingId: this.listingId,
        //        stockType: this.stockType,
        //        toCaptiveSRP: true,
        //        page: this.pageName
        //    });
        //};

        calcViewMoreTilePadding = function () {
            scope.viewMoreTilePadding = !hasEmptySlot() && ctrl.showViewMoreTile() ? 1 / ctrl.getCarsPerPage() : 0;
        };

        compDisableRightArrow = function () {
            if (hasEmptySlot()) {
                scope.disableRightArrow = scope.page === (scope.maxPage - 1);
            } else {
                scope.disableRightArrow = (scope.page >= (scope.maxPage - 1 + scope.viewMoreTilePadding));
            }
        };

        function hasEmptySlot() {
            return ((scope.resultsShow % ctrl.getCarsPerPage()) > 0);
        }
    }
}

component.$inject = ['pageStateService'];

export default component;
